import React, { useContext, useEffect, useState } from 'react';
import './ProjectNavbar.css';
import { Link, Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import ProjectContext from '../../context/project/ProjectContext';

function ConfigNavbar() {
  const projectContext = useContext(ProjectContext);
  const { selectProject, selectedProject, projects } = projectContext;
  const [activeTab, setActiveTab] = useState('Roles');

  const navigate = useNavigate();
  useEffect(() => {
    console.log('###selectProject:', selectProject);

    //eslint-disable-next-line
  }, [selectedProject]);

  const showUnits = (event) => {
    event.preventDefault();
    setActiveTab('Units');
    navigate('/config/units/');
  };

  const showRoles = (event) => {
    event.preventDefault();
    setActiveTab('Roles');
    navigate('/config/roles/');
  };

  const showClients = (event) => {
    event.preventDefault();
    setActiveTab('Clients');
    navigate('/config/clients/');
  };

  const showClientList = (event) => {
    event.preventDefault();
    setActiveTab('ClientList');
    navigate('/config/client-user/');
  };

  const showClientGroup = (event) => {
    event.preventDefault();
    setActiveTab('ClientGroup');
    navigate('/config/client-group/');
  };

  useEffect(() => {
    setActiveTab('Roles');
    // return () => {
    //   selectProject(null);
    // };
    //eslint-disable-next-line
  }, []);

  return (
    <header>
      <nav className='navbar navbar-inverse'>
        <div className='container-fluid cfl-nav'>
          <div className='navbar-header  nav-hd'>
            {/* <div className="underline-bg"></div> */}
            <a className='navbar-brand' href='#'>
              <b>Intelli-Fiber Settings</b>
            </a>
            <div className='underline-bg'></div>
          </div>

          <div className='btn2'>
            <button
              id='btn4'
              className={`${
                activeTab === 'ClientList' ? 'activeTab' : 'button'
              }`}
              onClick={showClientList}
            >
              CLIENTS
            </button>
            <button
              id='btn4'
              className={`${
                activeTab === 'ClientGroup' ? 'activeTab' : 'button'
              }`}
              onClick={showClientGroup}
            >
              CLIENT GROUPS
            </button>
            <button
              id='btn4'
              className={`${activeTab === 'Clients' ? 'activeTab' : 'button'}`}
              onClick={showClients}
            >
              CLIENT PORTAL
            </button>
            <button
              id='btn3'
              className={`${activeTab === 'Units' ? 'activeTab' : 'button'}`}
              onClick={showUnits}
            >
              UNITS
            </button>
            <button
              id='btn4'
              className={`${activeTab === 'Roles' ? 'activeTab' : 'button'}`}
              onClick={showRoles}
            >
              ROLES
            </button>
          </div>
        </div>
        <Outlet />
      </nav>
    </header>
  );
}

export default ConfigNavbar;
